/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  z as zod
} from 'zod'

/**
 * Lists credit facility borrowing base groups for a credit facility.
 */
export const creditFacilityBorrowingBaseGroupListParams = zod.object({
  "creditFacilityId": zod.string(),"fundFamilyId": zod.string()
})

export const creditFacilityBorrowingBaseGroupListQueryParams = zod.object({
  "version_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).optional()
})

/**
 * Upserts credit facility borrowing base groups for a credit facility.
 */
export const creditFacilityBorrowingBaseGroupsUpsertParams = zod.object({
  "creditFacilityId": zod.string(),"fundFamilyId": zod.string()
})

export const creditFacilityBorrowingBaseGroupsUpsertQueryParams = zod.object({
  "version_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).optional()
})

export const creditFacilityBorrowingBaseGroupsUpsertBodyBorrowingBaseGroupsAnnotationsSetMin = 2;
export const creditFacilityBorrowingBaseGroupsUpsertBodyBorrowingBaseGroupsAnnotationsSetMax = 2;

export const creditFacilityBorrowingBaseGroupsUpsertBody = zod.object({
  "borrowing_base_groups": zod.array( zod.object({
  "reason_for_change": zod.string().optional(),"version_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).or(zod.union([zod.null(), zod.literal("")])).optional(),"id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"annotations_set": zod.array(zod.array(zod.any()).min(creditFacilityBorrowingBaseGroupsUpsertBodyBorrowingBaseGroupsAnnotationsSetMin).max(creditFacilityBorrowingBaseGroupsUpsertBodyBorrowingBaseGroupsAnnotationsSetMax)).optional(),"credit_facility_id": zod.string().min(1),"name": zod.string().min(1),"rate": zod.string().min(1),"individual_concentration_limit": zod.string().or(zod.union([zod.null(), zod.literal("")])),"aggregate_concentration_limit": zod.string().or(zod.union([zod.null(), zod.literal("")]))
}))
})

/**
 * Upserts a single credit facility borrowing base group for a credit facility.
 */
export const creditFacilityBorrowingBaseGroupUpsertParams = zod.object({
  "creditFacilityId": zod.string(),"fundFamilyId": zod.string()
})

export const creditFacilityBorrowingBaseGroupUpsertBodyAnnotationsSetMin = 2;
export const creditFacilityBorrowingBaseGroupUpsertBodyAnnotationsSetMax = 2;

export const creditFacilityBorrowingBaseGroupUpsertBody = zod.object({
  "reason_for_change": zod.string().optional(),"version_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).or(zod.union([zod.null(), zod.literal("")])).optional(),"id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"annotations_set": zod.array(zod.array(zod.any()).min(creditFacilityBorrowingBaseGroupUpsertBodyAnnotationsSetMin).max(creditFacilityBorrowingBaseGroupUpsertBodyAnnotationsSetMax)).optional(),"credit_facility_id": zod.string().min(1),"name": zod.string().min(1),"rate": zod.string().min(1),"individual_concentration_limit": zod.string().or(zod.union([zod.null(), zod.literal("")])),"aggregate_concentration_limit": zod.string().or(zod.union([zod.null(), zod.literal("")]))
})

export const creditFacilityBorrowingBaseGroupUpsertResponseAnnotationsSetMin = 2;
export const creditFacilityBorrowingBaseGroupUpsertResponseAnnotationsSetMax = 2;

export const creditFacilityBorrowingBaseGroupUpsertResponse = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(creditFacilityBorrowingBaseGroupUpsertResponseAnnotationsSetMin).max(creditFacilityBorrowingBaseGroupUpsertResponseAnnotationsSetMax)).optional(),"credit_facility_id": zod.string().min(1),"id": zod.string().min(1),"name": zod.string().min(1),"rate": zod.string().min(1),"individual_concentration_limit": zod.string().or(zod.union([zod.null(), zod.literal("")])),"aggregate_concentration_limit": zod.string().or(zod.union([zod.null(), zod.literal("")]))
})

/**
 * Deletes a specific credit facility borrowing base group
 */
export const creditFacilityBorrowingBaseGroupDeleteParams = zod.object({
  "creditFacilityId": zod.string(),"fundFamilyId": zod.string()
})

export const creditFacilityBorrowingBaseGroupDeleteQueryParams = zod.object({
  "borrowing_base_group_id": zod.string()
})

